import { z } from 'zod'

import { passwordInputSchema } from '@/features/password-requirement/schema'

export const signupFormDataSchema = z.object({
    email: z.email(),
    password: passwordInputSchema,
    userAgreeTerms: z.stringbool(),
})
